export default __webpack_public_path__ + "static/media/denken_dan_doen.e7c15d0d.jpg";